import { createActionTypes } from "@helpers/redux-helpers";

export const getPostsActionTypes = createActionTypes("posts/getList");

export const createPostActionTypes = createActionTypes("posts/create");

export const deletePostActionTypes = createActionTypes("posts/delete");

export const getPortionActionTypes = createActionTypes("posts/getPortion");

export const updatePostActionType = "posts/update";

export const postUploadedActionType = "posts/postUploaded";

export const likePostActionTypes = createActionTypes("posts/like");

export const unlikePostActionTypes = createActionTypes("posts/unlike");

export const showPostByIdActionTypes = "posts/showReported";

export const getFeedPostsActionTypes = createActionTypes("feed/getList");

export const getFeedPurchasedPostsActionTypes = createActionTypes(
  "feed/purchased/getList",
);

export const getFeedPortionActionTypes = createActionTypes("feed/getPortion");
export const getFeedPurchasedPortionActionTypes = createActionTypes(
  "feed/purchased/getPortion",
);

export const setPostsActionTypes = createActionTypes("posts/set");

export const editPostActionTypes = createActionTypes("posts/edit");

export const pinPostActionTypes = createActionTypes("posts/pin");

export const unPinPostActionTypes = createActionTypes("posts/unpin");

export const updatePurchasedPostTypes = "posts/purchased";

export const toggleShowNewPostsButtonType = "posts/toggleNewPostsButton";

export const showNewPostsButtonType = "posts/showNewPostsButton";

export const toggleNewPostsLoadingType = "posts/showNewPostsLoading";

export const clearPostsType = "posts/clear";
